
import { Options, Vue } from 'vue-class-component';
import { CContainer } from '@coreui/vue';
import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';
import AppSidebar from '@/components/AppSidebar.vue';

@Options({
  name: 'CabinetLayout',
  components: {
    AppFooter,
    AppHeader,
    AppSidebar,
    CContainer,
  },
  watch: {
    $route(): void {
      this.$store.dispatch('initCashRegister');
    },
  },
})
export default class CabinetLayout extends Vue {
  created() {
    this.$store.dispatch('initProfile');
    this.$store.dispatch('initCashRegister');
  }
}
